import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Input from '../../Common/ui/input'
import { Button } from '../../Common/ui/button'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import { useTranslation } from 'react-i18next'
import { useCommonStore } from '../../Common/store/CommonStore'
import DropdownTextInput from '../../Common/ui/DropdownTextInput'
// import { Checkbox } from '../../Common/ui/checkbox'
import PhoneNumber from 'src/Common/ui/PhoneNumber'
import { IconButton, Tooltip } from '@mui/material'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import CustomSelect from 'src/Common/ui/CustomSelect'
import { useProfileScreenStore } from 'src/Containers/Onboarding/Store/OnboardingStore'
import * as EndPoints from '../../Entities/EndPoints'
import Axios from 'src/Axios'

const AddBoardDrawer = ({ nodes, newNode, setnewNode, currentNode, setAddState, addState, onAdd, childNodeCount, loading, setLoading }) => {
    const { t } = useTranslation()
    const { register, handleSubmit, reset, resetField, formState: { errors, isLoading, isSubmitting }, control, setValue, setError, clearErrors } = useForm({ mode: 'onChange' })
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const { getAllRole } = useCommonStore()
    const orgId = localStorage.getItem('orgId')
    const { getCountryData, getCountry } = useProfileScreenStore()
    const [ country, setCountry ] = useState([])
    const [ stateArrayData, setStateArrayData ] = useState([])
    const [ cityArrayData, setCityArrayData ] = useState([])

    useEffect(() => {
        getAllRole(orgId)
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const resetAll = () => {
        reset()
        resetField(OnboardEntity.PHONE_NUMBER)
    }

    const onSubmit = () => {
        setLoading(true)
        onAdd(currentNode, newNode, childNodeCount, resetAll)
        // setnewNode({})
    }

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }

        if (!open) {
            reset()
            resetField(OnboardEntity.PHONE_NUMBER)
            setnewNode({})
        }

        setAddState({ ...addState, [anchor]: open })
    }

    const handleAddFieldsChange = (value, name) => {
        setnewNode(prevNode => {
            const updatedNode = { ...prevNode, [name]: value }

            if (name === OnboardEntity.ADDRESS && !value) {
                updatedNode[OnboardEntity.PIN_CODE] = ''
            }
            // if (name === OnboardEntity.PHONE_NUMBER) {
            //     updatedNode[OnboardEntity.PHONE_NUMBER] = ''
            // }
            if (name === OnboardEntity.COUNTRY) {
                updatedNode[OnboardEntity.STATE] = null
                updatedNode[OnboardEntity.CITY] = null
                resetField(OnboardEntity.STATE)
                resetField(OnboardEntity.CITY)
            }
            return updatedNode
        })
        if (name === OnboardEntity.PHONE_NUMBER) {
            setnewNode({
                ...newNode,
                phoneCountryCode: value.countryCode,
                phoneCode: value.phNumberCode,
                phoneNumber: value.phNumber
            })
        }
    }

    const instance = Axios.getInstance()

    useEffect(() => {
        const fetchStates = async () => {
            if (newNode?.country) {
                try {
                    const response = await instance.get(
                    `${EndPoints.API_ENDPOINT}/masterController/states?id=${newNode.country}`
                    )
                    setStateArrayData(response?.data || [])
                } catch (error) {
                    console.error('Error fetching states:', error)
                }
            }
        }

        const fetchCities = async () => {
            if (newNode?.state) {
                try {
                    const response = await instance.get(
                    `${EndPoints.API_ENDPOINT}/masterController/cities?id=${newNode.state}`
                    )
                    setCityArrayData(response?.data || [])
                } catch (error) {
                    console.error('Error fetching cities:', error)
                }
            }
        }

        fetchStates()
        fetchCities()
    }, [ newNode?.country, newNode?.state ])

    useEffect(() => {
        getCountry()
    }, [])

    useEffect(() => {
        if (getCountryData?.length > 0) {
            setCountry(getCountryData)
        }
    }, [getCountryData?.length])

    const handleCancelClose = () => {
        setAddState({ ...addState, right: false })
        reset()
        resetField(OnboardEntity.PHONE_NUMBER)
        setnewNode({})
    }

    const list = (anchor) => (
        <Box className="p-4 h-[100%]">
            <div className="flex justify-between items-center pb-3 border-b-2">
                <h2 className="text-h2 text-primary">{t('Add Management Team')}</h2>
                <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                    <IconButton onClick={() => handleCancelClose()} aria-label="close" disabled={isSubmitting || isLoading || loading}>
                        <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                    </IconButton>
                </Tooltip>
            </div>
            <div className='flex flex-col h-[90%] justify-between'>
                <div className='mt-3 h-[90%]'>
                    <div className="grid grid-cols-3 gap-4 mb-2">
                        <div style={{ width: '100%' }}>
                            <DropdownTextInput
                                errors={errors}
                                control={control}
                                required
                                rules={{
                                    required: t('First Name is required'),
                                    validate: (value) => {
                                        const titleRegex = /^(Mr\.|Mrs\.|Ms\.|Mx\.|Dr\.)\s*/i
                                        const nameWithoutTitle = value.replace(titleRegex, '').trim()

                                        if (!nameWithoutTitle) {
                                            return t('First Name cannot be empty spaces')
                                        }
                                        const regex = /^[A-Za-z.]+$/
                                        if (!regex.test(nameWithoutTitle)) {
                                            return t('First Name must contain only letters')
                                        }
                                        if (nameWithoutTitle.length > 50) {
                                            return t('First Name must not exceed 50 characters')
                                        }
                                        return true
                                    }
                                }}
                                name='firstName'
                                label={t('First Name')}
                                placeholder={t('Enter First Name')}
                                value={newNode?.firstName || ''}
                                onValueChange={handleAddFieldsChange}
                                disabled={loading}
                            />
                        </div>
                        <div style={{ width: '100%' }}>
                            <Input
                                errors={errors}
                                control={control}
                                name='middleName'
                                label={t('Middle Name')}
                                register={register}
                                placeholder={t('Enter Middle Name')}
                                type="text"
                                value={newNode?.middleName || ''}
                                onValueChange={({ target: { value } }) => handleAddFieldsChange(value, 'middleName')}
                                rules={{
                                    validate: (value) => {
                                        const middleName = value?.trim()
                                        if (middleName?.length > 30) {
                                            return t('Middle Name must not exceed 30 characters')
                                        }
                                        return true
                                    }
                                }}
                                disabled={loading}
                            />
                        </div>
                        <div style={{ width: '100%' }}>
                            <Input
                                errors={errors}
                                control={control}
                                required
                                rules={{
                                    required: t('Last Name is required'),
                                    validate: (value) => {
                                        const regex = /^[A-Za-z]+$/
                                        const LastName = value.trim()
                                        if (!value.trim()) {
                                            return t('Last Name cannot be empty spaces')
                                        }
                                        if (!regex.test(value)) {
                                            return t('Last Name must contain only letters')
                                        }
                                        if (LastName.length > 30) {
                                            return t('Last Name must not exceed 30 characters')
                                        }
                                        return true
                                    }
                                }}
                                name='lastName'
                                label={t('Last Name')}
                                register={register}
                                placeholder={t('Enter Last Name')}
                                type="text"
                                value={newNode?.lastName || ''}
                                onValueChange={({ target: { value } }) => handleAddFieldsChange(value, 'lastName')}
                                disabled={loading}
                            />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input
                                errors={errors}
                                control={control}
                                required
                                name='emailId'
                                label={t('Email ID')}
                                register={register}
                                placeholder={t('Enter Email ID')}
                                type="text"
                                value={newNode?.emailId || ''}
                                onValueChange={({ target: { value } }) => handleAddFieldsChange(value, 'emailId')}
                                rules={{
                                    validate: (value) => {
                                        const regexEmail = /^[a-zA-Z0-9.+-_%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                        if (!value) {
                                            return t('Email is required')
                                        } else if (!regexEmail.test(value)) {
                                            return t('Enter a valid email')
                                        }
                                    },
                                    required: t('Email is required')
                                }}
                                disabled={loading}
                            />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            {/* <Input name={'phoneNo'} type='number' placeholder='Enter Phone Number' label='Phone Number' value={newNode?.phoneNo} onValueChange={({ target: { value } }) => handleAddFieldsChange(value, 'phoneNo')}
                                rules={{
                                    validate: (value) => {
                                        const regexPhone = /^[0-9]{10}$/
                                        if (value && !regexPhone.test(value)) {
                                            return 'Phone number must be 10 digits'
                                        }
                                    }
                                }} control={control} errors={errors} setError={setError} clearErrors={clearErrors}/> */}
                            <PhoneNumber
                                name={'phoneNo'}
                                required={true}
                                value={newNode?.phoneNumber ? `${newNode?.phoneCode || ''}${newNode?.phoneNumber}` : ''}
                                control={control}
                                placeholder={t('Enter phone number')}
                                label={t('Phone Number')}
                                register={register}
                                rules={{
                                    validate: (value) => {
                                        const regexPhone = /^[0-9]{10}$/
                                        if (value && !regexPhone.test(value)) {
                                            return 'Phone number must be 10 digits'
                                        }
                                    }
                                }}
                                errors={errors} setValue={setValue} setError={setError} clearErrors={clearErrors}
                                onValueChange={(value) => handleAddFieldsChange(value, OnboardEntity.PHONE_NUMBER)}
                                disabled={loading}
                            />
                        </div>
                        {/* <div style={{ width: '100%', justifyItems: 'center', marginBottom: '1rem', alignContent: 'center' }}>
                            <Checkbox
                                disabled
                                name="sendNotification"
                                checked={newNode?.sendNotification || false}
                                onCheckedChange={(e) => handleAddFieldsChange(e, 'sendNotification')}
                                className='mt-4'
                            />
                            <label className='grc-label-one ml-2'>{t('Do you want to send notification?')}</label>
                        </div> */}
                    </div>
                    <div className="grid grid-cols-3 gap-4 my-2">
                        <div className='col-span-2' style={{ width: '100%' }}>
                            <Input name='address' className="!w-[98%]" type='text' placeholder='Enter Apartment / House / Street' label='Apartment / House / Street' value={newNode?.address || ''} onValueChange={({ target: { value } }) => handleAddFieldsChange(value, 'address')}
                                rules={{
                                    validate: (value) => {
                                        if (value) {
                                            const address = value.trim()
                                            if (!value.trim()) {
                                                return t('Address cannot be empty spaces')
                                            }
                                            if (address.length > 50) {
                                                return t('Address must not exceed 50 characters')
                                            }
                                            return true
                                        }
                                        return true
                                    }
                                }} control={control} errors={errors}
                                disabled={loading}
                            />
                        </div>
                        <div className='col-span-1' style={{ width: '100%' }}>
                            <CustomSelect
                                name={'country'}
                                disabled={!newNode?.address || loading}
                                label={t('Country')}
                                value={newNode?.country || ''}
                                onValueChange={(value) => handleAddFieldsChange(value, 'country')}
                                options={country}
                                placeholder={t('Select country')}
                                errors={errors}
                                control={control}
                                required={newNode?.address}
                                rules={{ required: newNode?.address ? t('This field is required') : false }}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-3 gap-4 mb-2">
                        <div style={{ width: '100%' }}>
                            <CustomSelect
                                name={'state'}
                                disabled={!newNode?.address || loading || !newNode?.country}
                                label={t('State')}
                                value={newNode?.state || ''}
                                onValueChange={(value) => handleAddFieldsChange(value, 'state')}
                                options={stateArrayData}
                                placeholder={t('Select State')}
                                errors={errors}
                                control={control}
                                required={newNode?.address}
                                rules={{ required: newNode?.address ? t('This field is required') : false }}
                            />
                        </div>
                        <div style={{ width: '100%' }}>
                            <CustomSelect
                                name={'city'}
                                disabled={!newNode?.address || loading || !newNode?.state}
                                label={t('City')}
                                value={newNode?.city || ''}
                                onValueChange={(value) => handleAddFieldsChange(value, 'city')}
                                options={cityArrayData}
                                placeholder={t('Select City')}
                                errors={errors}
                                control={control}
                                required={newNode?.address}
                                rules={{ required: newNode?.address ? t('This field is required') : false }}
                            />
                        </div>
                        <div style={{ width: '100%' }}>
                            <Input disabled={!newNode?.address || loading}
                                name='pincode' required={newNode?.address}
                                errors={errors} control={control} rules={{ required: newNode?.address?.length > 0 ? t('This field is required') : false }}
                                type='number'
                                placeholder='Enter Pincode'
                                label='Pincode'
                                value={newNode?.address ? newNode?.pincode : ''}
                                onValueChange={({ target: { value } }) => handleAddFieldsChange(value, 'pincode')} />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="flex justify-end space-x-4">
                    <Button
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                        onClick={() => handleCancelClose()}
                        disabled={loading}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button onClick={() => { handleSubmit(onSubmit)() }} disabled={isSubmitting || isLoading || loading}>
                        {loading ? t('Saving...') : t('Save')}
                    </Button>
                </div>
            </div>
        </Box>
    )

    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 1.8, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={addState.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                {list('right')}
            </SwipeableDrawer>
        </div>
    )
}

AddBoardDrawer.propTypes = {
    setnewNode: PropTypes.func,
    currentNode: PropTypes.object,
    newNode: PropTypes.object,
    setAddState: PropTypes.func,
    addState: PropTypes.func,
    onAdd: PropTypes.func,
    childNodeCount: PropTypes.any,
    nodes: PropTypes.array,
    loading: PropTypes.bool,
    setLoading: PropTypes.bool
}

export default AddBoardDrawer
